// src/components/FooterBar.jsx
import React from "react";
import { FaPhone, FaEnvelope, FaTiktok, FaLinkedin, FaFilePdf } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import "./FooterBar.css";

const FooterBar = () => {
  return (
    <footer className="footer-bar">
      <div className="footer-content">

        {/* 📄 Nuevo ítem del Brochure */}
        <div className="footer-item">
          <FaFilePdf className="footer-icon" />
          <a
            href="https://www.eduialogic.com/BROCHURE%20EDUIALOGIC%209.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            PDF del Portafolio
          </a>
        </div>
        <div className="footer-item">
          <FaWhatsapp className="footer-icon" />
          <a
            href="https://wa.me/5731333853521?text=Hola%2C%20quiero%20más%20información%20sobre%20EduIAlogic"
            target="_blank"
            rel="noopener noreferrer"
          >
            Escríbenos...
          </a>
        </div>

        <div className="footer-item">
          <FaPhone className="footer-icon" />
          <a href="tel:+573133853521">+57 313 385 3521</a>
        </div>

        <div className="footer-item">
          <FaEnvelope className="footer-icon" />
          <a href="mailto:contacto@eduialogic.com">contacto@eduialogic.com</a>
        </div>

        <div className="footer-item">
          <FaTiktok className="footer-icon" />
          <a
            href="https://www.tiktok.com/@eduialogic"
            target="_blank"
            rel="noopener noreferrer"
          >
            @eduialogic
          </a>
        </div>

        <div className="footer-item">
          <FaLinkedin className="footer-icon" />
          <a
            href="https://www.linkedin.com/in/edu-ialogic/"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>
        </div>
      </div>
    </footer>
  );
};

export default FooterBar;

